<template>
	<div class="main-div">
		<div class="main-title-div">
			<span class="title">关键字配置</span>
			<!--切换关键词查看视图-->
			<div style="float: right;">
				<a @click="addMultiple=addMultiple == 0 ? 1 : 0">
					<i class="el-icon-cpu"></i>
					{{ addMultiple ? '关键字设置' : '批量添加' }}
				</a>
			</div>
		</div>

		<!--批量添加视图-->
		<div v-show="addMultiple == 1">
			<el-row :gutter="20">
				<el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
					<div class="body-left">
						<div style="margin-bottom: 10px;">
							<el-dropdown trigger="click" placement="bottom"
								style="width: 100%" disabled
								@command="(v) => country = v" >
								<el-button disabled style="width: 100%">
										<span style="font-size: 14px;color: #909399;">
											<i :class="'fi fi-' + getCountryObjByCity(country).icon"></i>
											{{ getCountryObjByCity(country).cn }}
											<i class="el-icon-arrow-down" style="margin-left: 5px;font-size: 14px;"></i>
										</span>
								</el-button>
								<el-dropdown-menu slot="dropdown" class="country-dropdown-20221111">
									<el-dropdown-item v-for="item in countryList" :key="item.value" style="width: 100%;"
										:disabled="country===item.value"
										:command="item.value">
										<i :class="'fi fi-' + item.icon.toLowerCase()"></i>{{ item.cn }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
						<div>
							<div class="search-tag-box-div">
								<div class="title-div">
									<span>关键词</span>
								</div>
								<div class="body-div">
									<div v-for="(i,index) in keywordsList" class="tag-div" :key="index">
										<div style="display: flex;">
											<div style="max-width: 200px;word-break:break-all;">{{ i }}</div>
											<div style="flex-grow: 0">
												<a @click="cancelKeywordsInsertLine(i)" style="margin-left: 10px;"
													class="el-icon-close"></a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
					<div class="body-right">
						<el-tabs class="el-tab-add-keywords-20220808">
							<el-tab-pane label="自定义添加" lazy>
								<div>
									<el-input type="textarea" :rows="16"
										:placeholder="'支持输入多个关键字和ASIN' + '\n' + '请用换行分割,按住ctrl + Enter可以换行,输入完毕请按回车键'"
										v-model="inputValue"
										@keyup.enter.native="handleInputConfirm"/>
								</div>
							</el-tab-pane>
							<el-tab-pane label="商品添加" lazy>
								<div>
									<asin-variant-list-sub  :addedAsins="asinList"
										@addAsin="addTableLines"></asin-variant-list-sub>
								</div>
							</el-tab-pane>
							<el-tab-pane label="关键词添加" lazy>
								<div style="height: 100%">
									<keywords-related-list :addedKeywords="keywordsList" :country="country"
										@addKeywords="addTableLines" ></keywords-related-list>
								</div>
							</el-tab-pane>
<!--							<el-tab-pane label="ASIN反查"></el-tab-pane>-->
						</el-tabs>
					</div>
				</el-col>
			</el-row>
			<!--ASIN展示-->
			<el-card shadow="never" class="asin-card-20230321" v-if="asinList && asinList.length > 0">
				<div class="asin-list">
					<div class="asin-item div-border-1" v-for="(item,index) in asinList"
						:key="index">
						<div v-if="item.loaded">
							<asin-info-sub :asin-info="item" :show-rank="false">
								<el-image fit="contain" style="height:68px;width: 68px"
									:src="item.imgs ? item.imgs[0] : ''">
									<template slot="error">
										<div style="line-height: 70px;font-family:monospace;">
											{{ item.asin }}
										</div>
									</template>
								</el-image>
							</asin-info-sub>
						</div>

						<div v-else style="line-height: 70px;vertical-align: middle;">
							<i class="el-icon-loading"></i>
						</div>
						<div class="remove-div" @click="cancelAsinInsertLine(item.asin)">
							<i class="el-icon-close"></i>
						</div>
					</div>
				</div>
			</el-card>
			<!--爬取配置-->
			<div style="margin-top: 20px;text-align: center;">
				<el-form label-width="100">
					<el-row>
						<el-col :span="8">
							<el-form-item label="搜索页码">
								<el-input-number disabled :min="1" :max="10" @change="multipleChange(null)"
									v-model="batchConfig.endPage"></el-input-number>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="类目">
								<el-select disabled v-model="batchConfig.categoryId">
									<el-option label="ALL Departments" value=""></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="追踪间隔(小时)">
								<el-input-number :min="2"
									v-model="batchConfig.period"></el-input-number>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>

		<!--表格单独设置视图-->
		<div class="monitor-table-duv" v-show="addMultiple==0">
			<el-table :data="monitorList"  border header-row-class-name="el-table-header-20220805">
				<el-table-column label="关键词" align="center" min-width="20%">
					<template slot-scope="scope">
						<el-input v-model="scope.row.keywords"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="商品详细" align="center"  min-width="30%">
					<template slot-scope="scope">
						<div class="asins-box-div" v-if="scope.row.asins">
							<el-button style="padding: 7px 5px" :disabled="scope.row.start==0"
								@click="scope.row.start--;scope.row.end--" size="mini" class="el-icon-arrow-left"></el-button>
							<div class="center-div">
								<div class="asin-image-box div-border-1"
									v-for="(item,index) in asinList.slice(scope.row.start,scope.row.end)" :key="index">
									<el-tooltip class="item" effect="dark" :content="item.asin" placement="top-start">
										<el-image style="width:100%;height:100%;"
											:src="item.imgs && item.imgs.length > 0 ? item.imgs[0] : ''">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</el-tooltip>
								</div>
							</div>
							<el-button style="padding: 7px 5px" :disabled="scope.row.end >= scope.row.asins.length -1"
								@click="scope.row.start++;scope.row.end++"
								size="mini" class="right-div el-icon-arrow-right"></el-button>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="页码" align="center" min-width="20">
					<template slot-scope="scope">
						<el-input-number disabled :min="1" :max="10"  size="small" @change="scope.row.changed=true"
							v-model="scope.row.endPage"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column label="分类" align="center" min-width="20%">
					<template slot-scope="scope">
						<el-select disabled v-model="scope.row.categoryId" size="small">
							<el-option label="ALL Departments" value=""></el-option>
						</el-select>
					</template>
				</el-table-column>
				<el-table-column label="间隔" align="center" min-width="20%">
					<template slot-scope="scope">
						<el-input-number :min="2" :max="48" @change="scope.row.changed=true" size="small"
							v-model="scope.row.period"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column min-width="12%" align="center">
					<template slot="header" slot-scope="scope">
						<el-button type="primary" @click="monitorList.push(JSON.parse(JSON.stringify(batchConfig)))"
							size="small">增加
						</el-button>
					</template>
					<template slot-scope="scope">
						<el-button type="danger" @click="cancelInsertLine(null,scope.$index)" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div class="footer-div">
			<el-button @click="close(null)">取消</el-button>
			<el-button type="primary" @click="submitAddMonitoring(null)"
				:disabled="addMonitorDisabled">
				<span v-if="!loading.addMonitor">提交</span>
				<span v-else>提交中 <i class="el-icon-loading"></i></span>
			</el-button>
		</div>
	</div>
</template>

<script>
import regular, { isAsin } from "@/components/common/utils/regular";
import ASIN_VARIANT_LIST from "@/components/template/view/keyword/monitoring2/asin/variantList";
import KEYWORD_RELATED_LIST from "@/components/template/view/keyword/monitoring2/keyword/keywordsRelated";
import { uniqueArr } from "@/components/common/utils/util";
import { api_addMonitoring_monitoring2 } from "@/components/api/keywordsMonitoring2";
import ASIN_INFO_SUB from "@/components/template/view/keywordsTrend/sub/asinInfoPopoverSub";
import { COUNTRY_CODE_MAP, getCountryObjByCity } from "@/components/config/countryCodeConfig";
import { api_asin_batchAsinInfoQuery_public } from "@/components/api/asinBasiceInfo";

export default {
	name: "addKeywords",
	inject: ['F_alertMsg', 'F_LOGIN','F_windowLoading', 'F_getErrMSg', 'KEYWORD_ADD_TAB', 'KEYWORD_REMOVE_TAB'],
	data() {
		return {
			loading: {
				addMonitor: false,
			},
			loadAsinLock : false,
			countryList: COUNTRY_CODE_MAP,
			inputValue: '',
			addMultiple: 1,
			country : COUNTRY_CODE_MAP[0].value,
			batchConfig: {
				startPage: 1,
				endPage: 3,
				categoryId: '',
				period: 8,
				asins: [],
				start : 0,
				end : 3
			},
			addAsinObj: {
				asin: '',
				errStatus: 0,
			},
			keywordsList: [],
			asinList: [],
			monitorList: []
		}
	},
	components: {
		'asin-variant-list-sub': ASIN_VARIANT_LIST,
		'keywords-related-list': KEYWORD_RELATED_LIST,
		'asin-info-sub': ASIN_INFO_SUB,
	},
	computed: {
		addMonitorDisabled() {
			let monitorList = this.$data.monitorList
			return this.$data.loading.addMonitor || monitorList.length <= 0 ||
				monitorList.filter(i => !i.keywords).length > 0 || this.$data.asinList.length <= 0
		}
	},
	created() {
	},
	methods: {
		cancelKeywordsInsertLine: function(text) {
			this.$data.keywordsList = this.$data.keywordsList.filter(i => i !== text)
			this.$data.monitorList = this.$data.monitorList.filter(i => i.keywords !== text)
		},
		cancelAsinInsertLine: function(text) {
			this.$data.asinList = this.$data.asinList.filter(i => i.asin !== text)
		},
		loadAsinInfo : function(this_) {
			this_ = this_ || this
			let asins = this_.$data.asinList.filter(i => !i.loaded).map(i => i.asin)
			if(asins.length <= 0 || this_.$data.loadAsinLock){
				return
			}
			// 上锁
			this_.$data.loadAsinLock = true
			api_asin_batchAsinInfoQuery_public(asins).then(res => {
				let data = res.data || []
				this_.$data.asinList.forEach((i,index) => {
					if (asins.indexOf(i.asin) !== -1){
						i.loaded = true
						let o = { ...i,...data.find(i => i.asin === i.asin)}
						if (o.imgs){
							o.product_image =  o.imgs[0] || ''
						}
						this_.$data.asinList[index] = o
					}
				})
				// 解锁
				this_.$data.loadAsinLock = false
			}).catch(err => {
				// 解锁
				this_.$data.loadAsinLock = false
				console.error(err)
			})
		},
		submitAddMonitoring: function(this_) {
			this_ = this_ || this
			// 开启遮罩
			this_.$data.loading.addMonitor = true
			let obj = JSON.parse(JSON.stringify(this_.$data.monitorList)).map(re => {
				re.asins = re.asins.map(o => o.asin)
				return re
			})
			api_addMonitoring_monitoring2(obj).then(res => {
				this_.F_LOGIN()
				//关闭遮罩
				this_.$data.loading.addMonitor = false
				this_.$data.monitorList = []
				this_.$data.asinList = []
				this_.$data.keywordsList = []
				this_.F_alertMsg("添加关键词监控成功", 2)
				this_.$options.methods.close(this_)
			}).catch(err => {
				//关闭遮罩
				this_.$data.loading.addMonitor = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '添加关键词监控失败'), 4)
			})

		},
		handleInputConfirm(e) {
			let inputValue = this.$data.inputValue;
			if (e.ctrlKey) {
				this.$data.inputValue += '\n'
				return
			}
			this.$data.inputValue = '';
			if (inputValue) {
				let strArr = inputValue.split(/[(\r\n)\r\n]+/)
				strArr.forEach(i => {
					if (i) {
						this.$options.methods.addTableLines(this, i,null)
					}
				})
			}
		},
		/**
		 * 添加关键字/ASIN
		 */
		addTableLines: function(this_, text , asinData,type) {
			this_ = this_ == null ? this : this_
			let monitorObj = JSON.parse(JSON.stringify(this_.$data.batchConfig));
			let monitorList = this_.$data.monitorList
			let asinList = this_.$data.asinList
			if (text && regular.amzAsin.test(text) && type !== 1) {
				if (!asinList.find(i => i.asin === text)) {
					this_.$data.asinList.push({asin : text,loaded : !!asinData , ...asinData})
					if (!asinData){
						this_.$options.methods.loadAsinInfo(this_)
					}
				}
			} else {
				let keywordsList = this_.$data.keywordsList
				if (keywordsList.indexOf(text) === -1) {
					keywordsList.push(text)
					// if (!monitorList.find(i => i.keywords === text)){
					monitorObj.keywords = text
					monitorObj.asins = [...asinList]
					monitorList.push(monitorObj)
					// }
				}
			}
			// console.log(this_.$data.asinList)
			// console.log(this_.$data.keywordsList)
			// console.log(monitorList)
		},
		/**
		 * 去除关键字
		 */
		cancelInsertLine: function(this_, index) {
			this_ = this_ || this
			this_.$data.monitorList.splice(index, 1)
		},
		close: function(this_) {
			this_ = this_ || this
			this_.$emit('success',false)
			// this.KEYWORD_REMOVE_TAB('addMonitor')
		},
		getCountryObjByCity: function(val) {
			return getCountryObjByCity(val)
		},
	},
	watch: {
		batchConfig : {
			handler(val) {
				console.log(val)
				let obj = JSON.parse(JSON.stringify(val))
				delete obj.asins
				this.$data.monitorList.forEach(i => {
					for (let key in obj) {
						i[key] = obj[key]
					}
				})
			},
			deep: true
		},
		asinList: {
			handler(val) {
				if (this.$data.monitorList.length > 0) {
					this.$data.monitorList.map(i => i.asins = uniqueArr(i.asins.concat(val)))
				}
			},
			deep: true
		},
		monitorList: {
			handler(val) {
			},
			deep: true
		}
	}
}
</script>

<style scoped>
.main-div {
	margin: 10px 20px;
}

.main-title-div {
	margin: 10px 0;
	height: 40px;
	line-height: 40px;
}
.main-title-div .title{
	margin-left: 10px;
	font-size: 24px;
	font-weight: bold;
	color: #555;
	border-left: 5px solid red;
	padding-left: 10px;
}

.body-left {

}

.body-left .add-div {
	margin-bottom: 15px;
}

.body-left .search-tag-box-div {
	border: 1px solid   #EBEEF5;
	border-radius: 5px;
	overflow: hidden;
	font-size: 14px;
}

.body-left .search-tag-box-div .title-div {
	background-color: #fafafa;
	padding: 15px;
	color: #8c8c8c;
	font-weight: bold;
	border-bottom: 1px solid  #EBEEF5;
}

.body-left .search-tag-box-div .body-div {
	overflow-y: auto;
	height: 300px;
	padding: 10px;
}

.body-left .tag-div {
	font-size: 13px;
	border-radius: 5px;
	border: 1px solid #dedede;
	padding: 10px 15px;
	margin: 5px;
	display: inline-block;
}

.asin-list{
	padding: 5px 0;
	overflow-x: auto;
	white-space:nowrap;
}
.asin-list .asin-item{
	width: 70px;
	text-align: center;
	display: inline-block;
	aspect-ratio:1/1;
	margin-right: 10px;
	padding: 2px;
	font-size: 10px;
	text-overflow:ellipsis;
	font-family:monospace;
	position: relative;
	vertical-align: middle;
}
.asin-list .asin-item .remove-div{
	position: absolute;
	display: inline-block;
	line-height: 15px;
	width: 15px;
	height: 15px;
	text-align: center;
	border-radius: 10px;
	color: #FFFFFF;
	background-color: #F56C6C;
	right: -5px;
	cursor: pointer;
	top: -5px;
}

.body-right {
	border: 1px solid   #EBEEF5;
	box-sizing: border-box;
	padding: 10px;
	border-radius: 4px;
}

.monitor-table-duv {
}
.asins-box-div {
	White-space: nowrap;
	height: 50px;
	line-height: 50px;
	display: flex;
}
.asins-box-div .right-div{
	justify-content: flex-end;
	margin-left: auto
}
.asins-box-div .center-div{
	display: flex;
	overflow: hidden;
}
.asins-box-div .asin-image-box{
	width: 50px;
	height: 100%;
	line-height: 40px ;
	padding: 4px;
	margin: 0 5px;
	box-sizing: border-box;
	position: relative;
}
.asins-box-div .asin-image-box .remove-div{
	padding: 0;
	margin: 0;
	border-radius: 0 0 0 50px;
	font-size: 12px;
	position: absolute;
	top: 2px;
	right: 2px;
}

.asins-box-div .tag-div {
	font-size: 12px;
	padding: 5px;
	margin: 0 6px;
	border-radius: 4px;
	border: 1px solid #E4E7ED;
	height: 80px;
	box-sizing: border-box;
	line-height: 70px;
}
.footer-div {
	text-align: center;
	padding: 20px;
}
</style>
<style>
.asin-card-20230321{
	margin-top: 20px;
}
.asin-card-20230321 .el-card__body{
	padding: 10px;
}
.el-form-20220805 .el-form-item {
}

.el-table-header-20220805 th {
	background-color: #f5f5f5 !important;
}

.el-tab-add-keywords-20220808 > .el-tabs__content {
	height: 350px;
	overflow-y: auto;
	position: relative;
}

.el-tab-add-keywords-20220808 > .el-tabs__content > .el-tab-pane {
	height: 100%;
}

</style>